<div class="batsu-maru-wrapper" *ngIf="isShow" [class.has-moisture]="isShowColMoiture">
    <div class="batsu-maru-display" [ngClass]="[labelConfig.highlight ? 'batsu-maru-attention' : '']">
        <div class="text-basu">{{ displayText }}</div>
         <div *ngIf="isShowColMoiture" class="batsu-maru-moisture">
            <label>{{ moisture }}</label>
        </div>
    </div>
</div>